import React, { useState } from 'react'
import Login from './Login'
import Signup from './Signup'
import AuthWrapper from './AuthWrapper'

const MainAuth = () => {
    const [isLogin, setIsLogin] = useState(true)
    const toggleAuthMode = () => {
        setIsLogin(!isLogin);
    };
  return (
    <>
        <section className='main-auth'>
            <div className='row'>
                <div className='col'>
                    <AuthWrapper/>
                </div>
                <div className='col'>
                    {isLogin ? <Login toggleAuthMode={toggleAuthMode}/> : <Signup toggleAuthMode={toggleAuthMode} />}
                </div>
            </div>
        </section>
    </>
  )
}

export default MainAuth